export default {
    'gps.details': 'Detalles',
    'gps.date': 'Fecha',
    'gps.hour': 'Hora',
    'gps.format.name': 'Nu. Interno',
    'gps.format.registerNumber': 'Patente',
    'gps.driver': 'Conductor',
    'gps.speed(Km/Hr)': 'Velocidad (Km/Hr) ',
    'gps.orientation': 'Orientación',
    'gps.coordinates': 'Coordenadas',
    'gps.address': 'Dirección',
    "gps.north": "Norte",
    "gps.northeast": "Noreste",
    "gps.east": "Este",
    "gps.southeast": "Sureste",
    "gps.south": "Sur",
    "gps.southwest": "Suroeste",
    "gps.west": "Oeste",
    "gps.northwest": "Noroeste",
    "gps.showimage": "Mostrar Imagen",
    "gps.showvideo": "Show Video",
    "gps.select.parentgroup": "Grupo Principal",
    "gps.select.group": "Grupo",
    "gps.select.nameregisternumber": "Patente / Numero Interno",
    "location": "Ubicación",
    "close": "Cerrar",
    "routingmap.osmMap": "Mapa de Ruta",
    "routingmap.hybridMap": "Mapa Híbrido",
    "routingmap.satelliteMap": "Mapa Satelital",
    "routingmap.googleTerrain": "Mapa del Terreno",
    "routingmap.standardMap": "Mapa Estandar",
    "routingmap.trafficMap": "Mapa de tráfico",
    "routingmap.hybirdtrafficMap": "Mapa de tráfico híbrido",
    "loading": "Buscando",
    "nooptions": "Sin opciones",
    "routecode": "Código",
    "submit": "Entregar",
    "enter_route_code": "Introduzca el código",
    "route_required": "Por favor ingrese el código",
    "no_data": "Sin datos",
    "updatePrompt.title": "Actualización Disponible",
    "updatePrompt.description": "Por favor haga clic en el botón actualizar ahora para actualizar la aplicación a la última versión",
    "updatePrompt.button": "Actualizar Ahora",
    "gps.navigation": "Navegación",
    "gps.streetview": "Vista de calle",
    "gps.youAreHere": "Tu ubicacion",
    "gps.distanceToYou": "Distancia a ti",
    "gps.yourLocation": "Tu ubicacion",
    "gps.closestVehicle": "Vehiculo mas cercano",
    "gps.geolocationUnsupported": "La geolocalizacion no es compatible con este navegador.",
    "gps.geolocationError": "No se pudo obtener tu ubicacion.",
    "gps.travelTime": "Tiempo estimado de viaje",
    "gps.travelTimeLessMinute": "<1 min",
    "gps.travelTimeMinutes": "{value} min",
    "gps.travelTimeHours": "{value} h",
    "gps.travelTimeHoursMinutes": "{hours} h {minutes} min",
    "monitor.bottomBar.vehicleDetails": "Detalle del vehiculo",
    "monitor.bottomBar.vehiclePlaceholder": "Vehiculo seleccionado",
    "monitor.bottomBar.expand": "Mostrar",
    "monitor.bottomBar.collapse": "Ocultar",
    "monitor.bottomBar.tabs.speed": "Velocidad",
    "monitor.bottomBar.tabs.batteryVoltage": "Voltaje de bateria",
    "monitor.bottomBar.tabs.batteryAmperage": "Amperaje de bateria",
    "monitor.bottomBar.tabs.rpm": "RPM",
    "monitor.bottomBar.tabs.soc": "Estado de carga",
    "monitor.bottomBar.noData": "Sin datos disponibles",
    "monitor.bottomBar.updated": "Ultima actualizacion",
    "monitor.bottomBar.latestValue": "Ultimo valor",
    "monitor.bottomBar.noSeriesData": "Sin datos para graficar",
    "monitor.bottomBar.historyLoading": "Cargando historial...",
    "monitor.bottomBar.historyError": "No fue posible cargar el historial.",
    "monitor.bottomBar.shortHistory.show": "Historial corto",
    "monitor.bottomBar.shortHistory.hide": "Ocultar historial corto",
    "monitor.bottomBar.shortHistory.timestamp": "Fecha",
    "monitor.bottomBar.shortHistory.address": "Direccion",
    "monitor.bottomBar.shortHistory.vehicle": "Vehiculo",
    "monitor.bottomBar.shortHistory.speed": "Velocidad (Km/Hr)",
    "monitor.bottomBar.shortHistory.orientation": "Orientacion",
    "monitor.bottomBar.shortHistory.ignition": "Ignicion",
    "monitor.bottomBar.actions.center": "Centrar en el mapa",
    "monitor.bottomBar.actions.follow.start": "Seguir vehiculo",
    "monitor.bottomBar.actions.follow.stop": "Dejar de seguir",
    "monitor.bottomBar.shortHistory.close": "Cerrar",
    "monitor.bottomBar.shortHistory.ignitionStateOn": "Encendido",
    "monitor.bottomBar.shortHistory.ignitionStateOff": "Apagado",
    "monitor.bottomBar.shortHistory.noTimestamp": "Fecha no disponible",
    "monitor.bottomBar.shortHistory.noAddress": "Direccion no disponible",
    "monitor.bottomBar.shortHistory.noSpeed": "Sin datos",
    "monitor.bottomBar.shortHistory.noVehicle": "Sin datos",
    "monitor.bottomBar.shortHistory.noOrientation": "Sin datos",
    "monitor.bottomBar.shortHistory.orientation.north": "Norte",
    "monitor.bottomBar.shortHistory.orientation.northeast": "Noreste",
    "monitor.bottomBar.shortHistory.orientation.east": "Este",
    "monitor.bottomBar.shortHistory.orientation.southeast": "Sureste",
    "monitor.bottomBar.shortHistory.orientation.south": "Sur",
    "monitor.bottomBar.shortHistory.orientation.southwest": "Suroeste",
    "monitor.bottomBar.shortHistory.orientation.west": "Oeste",
    "monitor.bottomBar.shortHistory.orientation.northwest": "Noroeste",
    "monitor.stats.title": "Resumen de flota",
    "monitor.stats.subtitle": "Estado en vivo segun los ultimos reportes.",
    "monitor.stats.total": "Flota Total",
    "monitor.stats.moving": "Movimiento",
    "monitor.stats.halted": "Ralentí",
    "monitor.stats.stopped": "Detenido",
    "monitor.stats.withoutSignal": "Sin Señal (>{days} días)"
};
